/**
 * The list's rows: the shared view-rows request at the list's address.
 *
 * What is different is what comes back *inside* a row: this endpoint joins the
 * target field of each linked row into the link cell, so a list can show a
 * column of the linked table other than its primary one. Nothing here has to
 * ask for that -- it is what the endpoint answers with.
 */
import { viewRowsFetcher } from '../views/view-rows'

const list = viewRowsFetcher('/api/database/views/list/{view_id}/')

export const fetchListRows = list.fetch
export const __setListRowFetcherForTests = list.setForTests
